import { Controller } from "@hotwired/stimulus"

// 診断結果ページのポーリング。結果はジョブで非同期生成されるため、
// 生成中は statusUrl(JSON) を一定間隔で叩き、ready(完成) または failed(生成失敗) に
// なったらページをリロードして結果 or 失敗画面（再実行ボタン）を描画する。
export default class extends Controller {
  static values = {
    statusUrl: String,
    intervalMs: { type: Number, default: 3000 }
  }

  connect() {
    this.active = true
    this.poll()
  }

  disconnect() {
    // 切断後は in-flight の fetch が完了しても次のタイマーを張らないようにする（ポーリングの張り付き防止）
    this.active = false
    if (this.timer) clearTimeout(this.timer)
  }

  async poll() {
    if (!this.active) return
    try {
      const response = await fetch(this.statusUrlValue, { headers: { "Accept": "application/json" } })
      if (!this.active) return
      if (response.ok) {
        const data = await response.json()
        // ready・failed はどちらもポーリングの終端。failed を無視すると永久にローディングになる。
        if (data.ready || data.failed) {
          window.location.reload()
          return
        }
      }
    } catch {
      // 通信失敗は無視して次の間隔で再試行する
    }
    if (!this.active) return
    this.timer = setTimeout(() => this.poll(), this.intervalMsValue)
  }
}
